<template>
	<div class="form-content">
		<van-form validate-trigger="onChange" ref="Form">
			<div class="form-content-title__sub" v-if="isCreated">购买信息</div>
			<nio-form-item
				:value="formData.ownerType"
				:rules="[{ required: true, message: '请选择购车类型', trigger: 'onChange' }]"
			>
				<template>
					<nio-radio-group
						v-model="formData.ownerType"
						@change="handleChange"
						class="owner-type-radio"
					>
						<nio-radio :label="1">个人购车</nio-radio>
						<nio-radio :label="2">企业购车</nio-radio>
					</nio-radio-group>
				</template>
			</nio-form-item>
			<nio-form-item
				:value="formatCityInfo(formData.registerCityInfo)"
				:rules="[{ required: true, message: '请选择上牌城市', trigger: 'onChange' }]"
				:readonly="true"
				v-if="isCreated"
			>
				<template #default="state">
					<nio-field
						:value="formatCityInfo(formData.registerCityInfo)"
						placeholder="请选择上牌城市"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
						:showRightIcon="true"
						:rightIconNameList="['icon_arrows_16']"
						@focus="updateShowAddressList(true)"
					/>
				</template>
			</nio-form-item>

			<div class="form-content-title__sub marginTop60" v-if="isCreated">车主信息</div>
			<div class="form-content-title__tips" v-if="isCreated">
				车主即车辆产权所有人，车主姓名和证件号码将使用在机动车销售统一发票，机动车登记证书和机动车行驶证
			</div>
			<nio-form-item
				:value="formData.ownerName"
				name="ownerName"
				:rules="[
					{
						required: true,
						validator: validateName,
						message: validateNameMessage,
						trigger: 'onChange'
					}
				]"
			>
				<template #default="state">
					<nio-field
						v-model="formData.ownerName"
						:maxLength="nameMaxLength"
						:placeholder="namePlaceholder"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
					/>
				</template>
			</nio-form-item>
			<nio-form-item
				v-if="formData.ownerType === 1"
				:value="formData.ownerPhone"
				:rules="[
					{
						required: true,
						validator: validateMobile,
						message: validateMobileMessage,
						trigger: 'onChange'
					}
				]"
			>
				<template #default="state">
					<nio-field
						v-model="formData.ownerPhone"
						:maxLength="11"
						placeholder="请输入车主手机号码"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
					/>
				</template>
			</nio-form-item>

			<nio-form-item
				v-if="formData.ownerType === 1"
				:value="formatCardTypeInfo(formData.cardTypeInfo)"
				:readonly="true"
				:rules="[{ required: true, message: '请选择证件类型', trigger: 'onChange' }]"
			>
				<template #default="state">
					<nio-field
						:value="formatCardTypeInfo(formData.cardTypeInfo)"
						placeholder="请选择证件类型"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
						:showRightIcon="true"
						:rightIconNameList="['icon_arrows_16']"
						@focus="updateCardTypeSelector(true)"
					/>
				</template>
			</nio-form-item>
			<nio-form-item
				:value="formData.ownerIdCode"
				:rules="[
					{
						required: true,
						validator: validateCard,
						message: validateCardMessage,
						trigger: 'onChange'
					}
				]"
			>
				<template #default="state">
					<nio-field
						v-model="formData.ownerIdCode"
						:placeholder="cardNumberMessage"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
					/>
				</template>
			</nio-form-item>
			<nio-form-item
				:value="formatCityInfo(formData.registerCityInfo)"
				:rules="[{ required: true, message: '请选择上牌城市', trigger: 'onChange' }]"
				:readonly="true"
				v-if="!isCreated"
			>
				<template #default="state">
					<nio-field
						:value="formatCityInfo(formData.registerCityInfo)"
						placeholder="请选择上牌城市"
						:status="state.error ? 'error' : 'normal'"
						:errorMessage="state.message"
						:showRightIcon="true"
						:rightIconNameList="['icon_arrows_16']"
						@focus="updateShowAddressList(true)"
					/>
				</template>
			</nio-form-item>
		</van-form>
		<CardTypeSelector
			:selectValue.sync="formData.cardTypeInfo"
			:cardPopupVisible.sync="cardTypeSelectorVisible"
			:options="actions"
		/>
		<AddressList v-model="formData.registerCityInfo" :show.sync="isShowAddressList" />
	</div>
</template>

<script>
import NioFormItem from '@/components/NioFormItem'
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import {
	queryVehicleDetail,
	regionAreaModel,
	createOrder,
	getCardType
} from '@/model'
import AddressList from '@/views1/OrderCreatorPage/AddressList'
import CardTypeSelector from '@/views1/OrderCreatorPage/CardTypeSelector.vue'
import { carDetailToCarItem } from '@/util/data-transfer'
import { PatternType, validatorPattern } from '@/util/constant.js'

export default {
	name: 'orderCreator',
	components: {
		NioFormItem,
		AddressList,
		CardTypeSelector
	},
	props: {
		//创建
		isCreated: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object
		}
	},
	data() {
		return {
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			car: null,
			formData: {
				//订单号
				orderNo: '',
				//车辆所有人类型
				ownerType: 1,
				//车辆所有人姓名
				ownerName: '',
				//车辆所有人手机号
				ownerPhone: '',
				ownerIdType: '',
				ownerIdCode: '',
				registerCityInfo: null,
				cardTypeInfo: null
			},
			pattern: /^\d+$/,
			cardPopupVisible: false,
			isShowAddressList: false,
			checked: false,
			cardTypeSelectorVisible: false,
			actions: [],
			options: [],
			currentAreaCode: ''
			//validateMobileMessage: "",
		}
	},
	computed: {
		carItemInfo() {
			if (!this.car) {
				return null
			}
			return carDetailToCarItem(this.car)
		},
		namePlaceholder() {
			return this.formData.ownerType === 1 ? '请输入车主姓名' : '请输入企业名称'
		},
		cardNumberMessage() {
			return this.formData.ownerType === 1 ? '请输入证件号码' : '请输入企业代码'
		},
		nameMaxLength() {
			return this.formData.ownerType === 1 ? 30 : 40
		}
	},
	created() {
		this.getCardType()
	},
	mounted() {},
	methods: {
		handleBack() {
			nativeHybrid.closeSyn()
		},
		userInfo() {
			nativeHybrid.getUserInfo()
		},
		updateCardPopupstatus(status) {
			if (!this.formData.registerCityInfo) {
				this.$toast('请先选择上牌城市')
				return
			}
			this.cardPopupVisible = status
		},
		updateShowAddressList(status) {
			this.isShowAddressList = status
		},

		formatCityInfo(registerCityInfo) {
			if (!registerCityInfo || !registerCityInfo.city) {
				return ''
			}
			return registerCityInfo.city.name
		},
		formatCardTypeInfo(cardTypeInfo) {
			if (!cardTypeInfo || !cardTypeInfo.name) {
				return ''
			}
			return cardTypeInfo.name
		},
		validateName(val) {
			if (this.formData.ownerType && this.formData.ownerType === 1) {
				if (!val) {
					return false
				} else if (!/^[.\u4E00-\u9FA5a-zA-Z]{1,30}$/.test(val)) {
					return false
				} else if (val && val.length > 30) {
					return false
				} else {
					return true
				}
			} else if (this.formData.ownerType && this.formData.ownerType === 2) {
				if (!val) {
					return false
				} else if (!validatorPattern[PatternType.CompanyName].test(val)) {
					return false
				} else if (val && val.length > 60) {
					return false
				} else {
					return true
				}
			}
		},
		validateNameMessage(val) {
			if (this.formData.ownerType && this.formData.ownerType === 1) {
				if (!val) {
					return '请输入车主姓名'
				} else if (!/^[.\u4E00-\u9FA5a-zA-Z]{1,30}$/.test(val)) {
					return '请输入符合规范的车主姓名'
				} else if (val && val.length > 30) {
					return '车主姓名最大为30位'
				} else {
					return ''
				}
			} else if (this.formData.ownerType === 2) {
				if (!val) {
					return '请输入企业名称'
				} else if (!validatorPattern[PatternType.CompanyName].test(val)) {
					return '请输入符合规范的企业名称'
				} else if (val && val.length > 40) {
					return '企业名称最大为40位'
				} else {
					return ''
				}
			}
		},
		validateMobile(val, rules) {
			if (!val) {
				return false
			} else if (!/^\d+$/.test(val)) {
				return false
			} else if (val && val.length > 11) {
				return false
			} else {
				return true
			}
		},
		validateMobileMessage(val) {
			if (!val) {
				return '请输入手机号码'
			} else if (!/^\d+$/.test(val)) {
				return '请输入数字'
			} else if (val && val.length > 11) {
				return '手机号码已超过11位'
			} else {
				return ''
			}
		},
		validateCard(val) {
			let pattern = ''
			if (this.formData.ownerType === 1) {
				if (this.formData.cardTypeInfo) {
					pattern = validatorPattern[this.formData.cardTypeInfo.value]
				}
			} else if (this.formData.ownerType === 2) {
				pattern = validatorPattern[7]
			}

			if (!pattern) {
				return false
			}
			if (!pattern.test(val)) {
				return false
			} else {
				return true
			}
		},
		validateCardMessage(val) {
			let pattern = ''
			if (this.formData.ownerType === 1) {
				if (this.formData.cardTypeInfo) {
					pattern = validatorPattern[this.formData.cardTypeInfo.value]
				}
				if (!pattern) {
					return '请先选择证件类型'
				}
				if (!pattern.test(val)) {
					return '请输入正确格式的证件号码'
				} else {
					return ''
				}
			} else if (this.formData.ownerType === 2) {
				pattern = validatorPattern[7]
				if (!pattern) {
					return '请先选择证件类型'
				}
				if (!pattern.test(val)) {
					return '请输入正确格式的统一社会信用代码'
				} else {
					return ''
				}
			}
		},
		async getCardType() {
			try {
				const { data } = await getCardType.get({})
				if (!data || data.result_code !== 'success') {
					throw new Error()
				}
				this.actions = data.data.map(item => {
					return {
						name: item.desc,
						value: item.code
					}
				})
			} catch (error) {}
		},
		updateCardTypeSelector(val) {
			this.cardTypeSelectorVisible = val
		},
		handleChange(val) {
			this.formData.ownerName = ''
			this.formData.ownerPhone = ''
			this.formData.ownerIdType = ''
			this.formData.ownerIdCode = ''
			this.formData.registerCityInfo = null
			this.formData.cardTypeInfo = null

			setTimeout(() => {
				this.$refs.Form.resetValidation()
			})
		}
	},
	watch: {
		value: {
			handler(val, oldVal) {
				this.formData = val
			},
			deep: true
		},
		formData: {
			handler(val, oldVal) {
				if (val && val.registerCityInfo && val.registerCityInfo.city.area_code) {
					this.currentAreaCode = val.registerCityInfo.city.area_code
				}
				this.$emit('input', val)
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.form-content {
	font-family: 'PingFang SC';

	::v-deep {
		.nio-field {
			width: 100%;
		}
		.van-field__body {
			height: 60px;
		}

		.nio-select {
			width: 100%;
		}
		.nio-sheet {
			&__header {
				padding: 12px 20px 12px 20px;
				height: 50px;
				@include subtitle_2(1.4, 700);
				color: $text_primary;
			}
			&__content {
				@include body_1(1.5, 400, false);
				padding: 20px;
			}
		}

		.van-cell {
			padding: 0 0;
			&::after {
				display: none;
			}
		}
	}
	.owner-type-radio {
		::v-deep {
			.nio-radio__label {
				color: #000000;
			}
		}
	}
	&-title {
		@include headline_1(1.4, 400, false);
		color: $text_primary;
		&__tips {
			@include subtitle_4(1.5, 400, false);
			color: $text_secondary;
			margin-bottom: 35px;
		}
		&__sub {
			@include headline_3(1.4, 400, false);
			color: $text_primary;
			margin-bottom: 20px;
		}
	}
	&-price-block {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid $text_primary;
		padding: 15px 20px;
		margin-bottom: 30px;
		&__label {
			@include body_1(1.5, 500, false);
			color: $text_primary;
		}
		&__value {
			color: $text_primary;
			@include body_1(1.5, 700, false);
		}
	}

	.section-car-card {
		margin-top: 45px;
		margin-bottom: 60px;

		::v-deep {
			.img-container {
				width: 100px !important;
				height: 100px !important;
			}

			.price-line {
				display: none;
			}

			.car-name {
				.nio-icon {
					display: none;
				}
			}
		}
	}
	.agreement {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		::v-deep {
			.nio-button {
				padding: 0 0;
				font-family: 'PingFang SC';
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				line-height: 20px;
			}
			.nio-check {
				padding-left: 0;
			}
		}
	}
}
.marginTop60 {
	margin-top: 60px;
}
</style>
